import { PersonAddress } from './personAddress';
import { TenantGeneralData } from './tenantGeneralData';
import { User } from './user';
import { PersonContact } from './personContact';

export class Person extends TenantGeneralData {
  firstName: string = null;
  lastName: string = null;
  pictureUrl: string = null;
  gender: string = null;
  nationality: string = null;
  dateOfBirth: Date = null;
  note: string = null;
  user: User = null;
  vat: string = null;
  fiscalCode: string = null;
  // TODO Check only for italy (PEC)
  legalMail: string = null;
  legalName: string = null;
  techName: string = null;
  addresses: Array<PersonAddress> = [];
  contacts: Array<PersonContact> = [];

  constructor() {
    super();
  }
}
